export const theme = {
  primaryColor: 'blue',
  secondaryColor: 'green',
  blueBg3: '#2A2F4A',
  blueBg2: '#3F445C',
  blueBg1: '#43618F',
  blue800: '#2565CB',
  blue700: '#3A7BDF',
  blue600: '#6195E6',
  blue500: '#9DBDEF',
  blue400: '#A9CBFF',
  blue300: '#C8DEFF',
  blue200: '#E5F0FF',
  blue100: '#F4F9FF',
  gray900: '#000000',
  gray800: '#414447',
  gray700: '#5C656C',
  gray600: '#9199A4',
  gray500: '#B4BCC6',
  gray400: '#D0DAE3',
  gray300: '#E5E9ED',
  gray200: '#F1F5F8',
  gray100: '#F9F9FA',
  white: '#FFFFFF',
  error: '#EE5151',
  success: '#2BDA90',
  textStyles: {
    subtitle1: {
      fontSize: '40px',
      lineHeight: '1.5',
    },
    subtitle2: {
      fontSize: '32px',
      lineHeight: '1.5',
    },
    subtitle3: {
      fontSize: '28px',
      lineHeight: '1.5',
    },
    subtitle4: {
      fontSize: '24px',
      lineHeight: '1.5',
    },
    subtitle5: {
      fontSize: '16px',
      lineHeight: '1.5',
    },
    button: {
      fontSize: '15px',
      lineHeight: '1.6',
    },
    body1: {
      fontSize: '16px',
      lineHeight: '1.5',
    },
    body2: {
      fontSize: '14px',
      lineHeight: '1.6',
    },
    caption: {
      fontSize: '12px',
      lineHeight: '1.5',
    },
  },
  shadows: {
    shadow1: {
      shadow: '0px 4px 8px rgba(0, 0, 0, 0.04)',
    },
    shadow2: {
      shadow: '0px 8px 16px rgba(0, 0, 0, 0.16)',
    },
    shadow3: {
      shadow: '0px 12px 40px rgba(0, 0, 0, 0.12)',
    },
  },
};
